<template>
  <div>
    <button @click="goBackToPages">Organize pages</button>
    <h3>Share album</h3>
    <div class="share">
      <div>
        Right click this link and choose 'Copy link address': <router-link :to="viewAlbumLink">Album link</router-link>
      </div>
      <div class="or">
        or...
      </div>
      <div class="copy-section">
        <div class="link-to-copy">{{viewAlbumLinkText}}</div>
        <button @click="copy">Copy link to clipboard</button>
      </div>
    </div>
  </div>
</template>

<script>
import { viewAlbum, albumPages } from '../utils/routing'
export default {
  props: ['album'],
  data() {
    return {
    }
  },
  computed: {
    viewAlbumLink() {
      return viewAlbum(this.album)
    },
    viewAlbumLinkText() {
      const a = document.createElement('a');
      a.href = this.$router.resolve(viewAlbum(this.album)).href;
      return a.protocol + "//" + a.host  + a.pathname + a.search + a.hash;
    },
  },
  methods: {
    copy() {
      // I got this from: https://codepen.io/shaikmaqsood/pen/XmydxJ
      const $temp = document.createElement('input')
      document.querySelector('body').append($temp)
      const link = this.$el.querySelector('.link-to-copy')
      $temp.value = link.innerText
      $temp.select()
      document.execCommand('copy')
      $temp.remove()
    },
    goBackToPages() {
      this.$router.push(albumPages(this.album))
    },
  },
}
</script>

<style lang="stylus" scoped>
.share
  display flex
  flex-direction column
  justify-content center
  align-items center
  padding 100px
  font-size x-large
  border 1px silver dashed
  border-radius 20px

input
  width 300px

.or
  font-style italic
  padding 20px

.copy-section
  text-align center
</style>
